<template>
  <div class="new-input-box" style="width: 835px">
    <jd-title label="曝光商品" type="bold" v-if="isShowExposure"></jd-title>
    <el-form-item label="曝光商品:" class="zindexBox" v-if="isShowExposure">
      <el-checkbox v-model="exposureSwitch" @change="exposureSwitchChange">
        是否添加曝光商品
      </el-checkbox>
      <jd-button
        :class="[{ 'global-view-btn': backgroundOpacity }]"
        style="margin: 0 12px"
        @click="exposureProducts"
        :disabled="exposureSwitch == false"
        v-if="this.multiShopGoods.length <= 1"
      >
        {{
          itemListForData.length != ""
            ? "添加曝光商品" + "(" + itemListForData.length + "/20" + ")"
            : "添加曝光商品"
        }}
      </jd-button>
      <el-radio-group
        v-model="ruleForm.radio"
        :disabled="exposureSwitch == false"
        v-if="this.multiShopGoods.length <= 1"
      >
        <el-radio :label="0">显示京东价</el-radio>
        <!-- <el-radio :label="1">显示促销价</el-radio> -->
      </el-radio-group>
      <draggable
        v-if="this.multiShopGoods.length <= 1 && itemListForData.length > 0"
        v-model="itemListForData"
        chosen-class="chosen"
        :scroll="true"
        animation="150"
        force-fallback="true"
        @start="isDragging = true"
        @end="onEnd"
        style="
          margin-top: 10px;
          background: rgba(38, 112, 251, 0.06);
          padding: 10px;
        "
        filter=".unmover"
      >
        <transition-group type="transition">
          <div
            v-for="(item, index) in itemListForData"
            :key="item.skuId"
            style="display: inline-block; position: relative"
            class="show_upImg2"
          >
            <img
              :src="item.logo"
              width="120px"
              height="120px"
              style="display: inline-block"
            />&nbsp;
            <div class="delectPosible">
              <span class="delectSort">拖动排序</span>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                @click.stop="delec(index)"
                class="delectIcom"
              />
            </div>
          </div>
        </transition-group>
      </draggable>
    </el-form-item>
    <el-form-item label="添加商品:" class="zindexBox" v-if="!isShowExposure&&this.multiShopGoods.length <= 1">
      <jd-button
        :class="[{ 'global-view-btn': backgroundOpacity }]"
        style="margin: 0 12px"
        @click="exposureProducts"
        :disabled="exposureSwitch == false"
        v-if="this.multiShopGoods.length <= 1"
      >
        添加商品（{{itemListForData.length}}/{{limitNum}}）
      </jd-button>
      <draggable
        v-if="this.multiShopGoods.length <= 1 && itemListForData.length > 0"
        v-model="itemListForData"
        chosen-class="chosen"
        :scroll="true"
        animation="150"
        force-fallback="true"
        @start="isDragging = true"
        @end="onEnd"
        style="
          margin-top: 10px;
          background: rgba(38, 112, 251, 0.06);
          padding: 10px;
        "
        filter=".unmover"
      >
        <transition-group type="transition">
          <div
            v-for="(item, index) in itemListForData"
            :key="item.skuId"
            style="display: inline-block; position: relative"
            class="show_upImg2"
          >
            <img
              :src="item.logo"
              width="120px"
              height="120px"
              style="display: inline-block"
            />&nbsp;
            <div class="delectPosible">
              <span class="delectSort">拖动排序</span>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                @click.stop="delec(index)"
                class="delectIcom"
              />
            </div>
          </div>
        </transition-group>
      </draggable>
    </el-form-item>
    <template v-if="exposureSwitch && multiShopGoods.length > 1">
      <el-form-item label="多店铺商品:">
        <el-radio-group
          v-model="defaultMultiShopSkuType"
          @change="changeShopTypeChange"
        >
          <el-radio :label="0">统一配置</el-radio>
          <el-radio :label="1">按店铺配置</el-radio>
          <el-tooltip effect="light" placement="top">
            <template #content>
              <div>
                1、统一配置:
                配置后用户通过任意店铺活动路径进入活动都展示所有统一配置的商品;
              </div>
              <div>
                2、按店铺配置：按店铺配置后,通过指定店铺进入即展示指定店铺配置的曝光商品
              </div>
            </template>
            <el-button type="text" style="width: 35px">
              <i class="el-icon-question grey-color"></i>
            </el-button>
          </el-tooltip>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商品所属店铺:" v-if="defaultMultiShopSkuType == 0">
        <el-radio-group v-model="multiShopId" @change="changeRadioShop">
          <el-radio
            :label="item.venderId"
            v-for="(item, index) in multiShopGoods"
            :key="item.venderId"
            >{{ item.shopTitle }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="添加商品:" v-if="defaultMultiShopSkuType == 0">
        <jd-button
          :class="[{ 'global-view-btn': backgroundOpacity }]"
          @click="exposureProducts"
        >
          添加商品（{{ itemListForData.length }}/{{ limitNum }}）
        </jd-button>
      </el-form-item>
      <el-form-item label="添加商品:" v-if="defaultMultiShopSkuType == 1">
        <jdTab
          :tabsList="newList"
          :fatherTabAct="multiShopId"
          @tab-click="getShopList"
        />
        <jd-button
          :class="[{ 'global-view-btn': backgroundOpacity }]"
          @click="exposureProducts"
        >
          添加商品（{{ multiGoodsList[currentIndex].goodsList.length }}/{{
            limitNum
          }}）
        </jd-button>
      </el-form-item>
      <el-form-item>
        <draggable
          v-if="commonGoodsList.length > 0"
          v-model="commonGoodsList"
          chosen-class="chosen"
          :scroll="true"
          animation="150"
          force-fallback="true"
          @start="isDragging1 = true"
          @end="onEnd1"
          style="
            margin-top: 10px;
            background: rgba(38, 112, 251, 0.06);
            padding: 10px;
          "
          filter=".unmover"
        >
          <transition-group type="transition">
            <div
              v-for="(item, index) in commonGoodsList"
              :key="item.skuId"
              style="display: inline-block; position: relative"
              class="show_upImg2"
            >
              <img
                :src="item.logo"
                width="120px"
                height="120px"
                style="display: inline-block"
              />&nbsp;
              <div class="delectPosible">
                <span class="delectSort">拖动排序</span>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                  @click.stop="delec1(index)"
                  class="delectIcom"
                />
              </div>
            </div>
          </transition-group>
        </draggable>
      </el-form-item>
    </template>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="commonGoodsList"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="isLimit"
      :limitNum="limitNum"
      :disabled="backgroundOpacity"
      :venderId="multiShopId"
      :isInteract="true"
      :isSupportVirtualGroup="isSupportVirtualGroup"
    >
    </selectGoodsMonitor>
  </div>
</template>
<script>
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import draggable from "vuedraggable";
export default {
  components: {
    selectGoodsMonitor,
    draggable,
  },
  model: {
    prop: "itemListFor",
    event: "itemListForUpdate",
  },
  props: {
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    defaultExposureSwitch: {
      type: Boolean,
      default: false,
    },
    itemListFor: {
      type: Array,
      default: [],
    },
    isLimit: {
      type: Boolean,
      default: false,
    },
    limitNum: {
      type: Number,
      default: 20,
    },
    // 下单店铺已勾选的店铺
    multiShopGoods: {
      type: Array,
      default: [],
    },
    multiShopSkuType: {
      type: Number,
      default: 0,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    skuBelongVenderId: {
      type: String,
      default: "",
    },
    isShowExposure: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    itemListForData: {
      get: function () {
        return this.itemListFor;
      },
      set: function (val) {
        this.$emit("itemListForUpdate", val);
      },
    },
    newList() {
      return this.multiShopGoods.map((item) => {
        return {
          title: item.shopTitle,
          tabKey: item.venderId,
        };
      });
    },
    commonGoodsList: {
      get: function () {
        if (this.multiShopGoods.length > 1) {
          if (this.defaultMultiShopSkuType == 1) {
            return this.multiGoodsList[this.currentIndex].goodsList;
          } else {
            return this.itemListForData;
          }
        } else {
          return this.itemListForData;
        }
      },
      set: function (val) {
        // 如何给commonGoodsList赋值
        if (this.multiShopGoods.length > 1) {
          if (this.defaultMultiShopSkuType == 1) {
            // 按店铺配置时，更新对应店铺的商品列表
            this.multiGoodsList[this.currentIndex].goodsList = val;
          } else {
            // 统一配置时，更新 itemListForData
            this.itemListForData = val;
          }
        } else {
          // 单店铺时，更新 itemListForData
          this.itemListForData = val;
        }
      },
    },
    defaultMultiShopSkuType: {
      get: function () {
        return this.multiShopSkuType;
      },
      set: function (val) {
        this.$emit("update:multiShopSkuType", val);
      },
    },
    venderId() {
      // 当前店铺id
      return this.$store.getters.loginUserInfo.venderId;
    },
  },
  watch: {
    exposureSwitch(val) {
      this.$emit("update:defaultExposureSwitch", val);
    },
    defaultExposureSwitch(val) {
      this.exposureSwitch = val;
    },
    multiShopGoods: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          console.log("multiShopGoods", newVal);

          this.multiShopId = +this.skuBelongVenderId || newVal[0].venderId;
          this.multiGoodsList = newVal.map((item) => {
            return {
              venderId: item.venderId,
              goodsList: [],
            };
          });
        }
        if (newVal.length == 1) {
          this.defaultMultiShopSkuType = 0;
          this.multiShopId = this.venderId;
          this.itemListForData = this.itemListForData.filter(
            (item) => item.belongVenderId == this.venderId
          );
        }
      },
      immediate: true,
      deep: true,
    },
    itemListForData: {
      handler(newVal, oldVal) {
        if (
          this.isEdit &&
          !this.isShowMultiGoods &&
          this.defaultMultiShopSkuType == 1 &&
          this.multiGoodsList.length > 0
        ) {
          this.multiGoodsList.forEach((shop) => {
            this.itemListFor.forEach((item) => {
              if (item.belongVenderId == shop.venderId) {
                shop.goodsList.push(item);
              }
            });
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isSupportVirtualGroup: true,
      isShowMultiGoods: false,
      currentIndex: 0,
      multiGoodsList: [],
      exposureSwitch: false,
      ruleForm: {
        radio: 0,
      },
      multiShopId: "",
      selectGoodsState: false,
      mainImagelist: [],
      draggingId: [],
      selectGoodsList: [],
      isDragging1: false,
      isDragging: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    changeShopTypeChange(val) {
      this.itemListForData = [];
      this.multiShopId = this.multiShopGoods[0].venderId;
    },
    changeRadioShop(val) {
      this.itemListForData = [];
    },
    getShopList(row) {
      this.multiShopId = row.name;
      this.currentIndex = row.index;
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.itemListForData.forEach((item) => {
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //图片拖拽
    onEnd1() {
      this.isDragging1 = false;
      //拖拽完成后的顺序
      let arr = [];
      this.commonGoodsList.forEach((item) => {
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //删除
    delec(index) {
      let itemListForData = JSON.parse(JSON.stringify(this.itemListForData));
      itemListForData.splice(index, 1);
      this.itemListForData = itemListForData;
    },
    //删除
    delec1(index) {
      let arr = [];
      if (this.multiShopGoods.length > 1) {
        if (this.defaultMultiShopSkuType == 1) {
          arr = this.multiGoodsList[this.currentIndex].goodsList;
          arr.splice(index, 1);
          this.multiGoodsList[this.currentIndex].goodsList = arr;
        } else {
          arr = this.itemListForData;
          arr.splice(index, 1);
          this.itemListForData = arr;
        }
      } else {
        arr = this.itemListForData;
        arr.splice(index, 1);
        this.itemListForData = arr;
      }
    },
    exposureSwitchChange(val) {
      if (!val) {
        this.itemListForData = [];
      }
      this.$forceUpdate();
    },
    selectGoodsClose(data) {
      if (data) {
        this.itemListForData = [];
        this.selectGoodsList = [];
        let itemListForData = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          if (this.multiShopGoods.length <= 1) {
            fomeVaule.belongVenderId = this.venderId;
          }
          if(!this.isShowExposure) {
            fomeVaule.sort = index;
          }
          itemListForData.push(fomeVaule);
        });
        if (this.isEdit) {
          this.isShowMultiGoods = true;
        }
        this.itemListForData = itemListForData;
        // // 多店铺商品接收
        if (this.multiShopGoods.length > 1) {
          if (this.defaultMultiShopSkuType == 1) {
            this.multiGoodsList[this.currentIndex].goodsList = itemListForData;
            this.multiGoodsList.forEach((item) => {
              if (item.goodsList.length > 0) {
                item.goodsList.forEach((row,index) => {
                  this.selectGoodsList.push({
                    ...row,
                    belongVenderId: item.venderId,
                  });
                });
              }
            });
            this.itemListForData = this.selectGoodsList;
          } else {
            this.itemListForData = itemListForData.map((item,index) => {
              return {
                ...item,
                belongVenderId: this.multiShopId,
              };
            });
          }
        }
      }
      this.selectGoodsState = false;
    },

    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      if (this.itemListForData.length == 0) {
        this.itemListForData = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
  },
};
</script>
<style lang="scss" scoped>
.grey-color {
  color: #ccc;
}
</style>
